import {create} from 'zustand'

interface LoginDialogStore {
  open: boolean
  setOpen: (open: boolean) => void
  openLoginDialog: () => void
  closeLoginDialog: () => void
}

export const useLoginDialogStore = create<LoginDialogStore>((set) => ({
  open: false,
  setOpen: (open) => set({open}),
  openLoginDialog: () => set({open: true}),
  closeLoginDialog: () => set({open: false}),
}))

/** Opens the shared dialog from event handlers that are outside React render. */
export function openLoginDialog(): void {
  useLoginDialogStore.getState().openLoginDialog()
}
